export default __webpack_public_path__ + "static/media/madame_perspective.5fa4c403.jpg";